import { MoneyPurchaseAnnualAllowanceSource } from "../../../../../../Wrap/Constants/Enums/Apply/MoneyPurchaseAnnualAllowanceSource";
import { BankAccountOwner } from "../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { DepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/DepositMethod";
import { AccountAdviceType } from "../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { PensionType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SippDrawdownType } from "../../../../../../Wrap/Constants/Enums/Domain/SippDrawdownType";
import { RegularDepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WithdrawalMethod } from "../../../../../../Wrap/Constants/Enums/Domain/WithdrawalMethod";
import { ExternalIsaContributionType } from "../../../../../../Wrap/Constants/Enums/Transfer/ExternalIsaContributionType";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../Shared/Entities/Constants/DateConstants";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { SourceType } from "../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { PaymentMethod } from "../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { FrequencyType } from "../../../../../../Wrap/Constants/Enums/Domain/FrequencyType";
import { ArrangementType } from "../../../../../../Wrap/Constants/Enums/Domain/ArrangementType";
import { OrderDeferReasonType } from "../../../../../../Wrap/Constants/Enums/Orders/OrderDeferReasonType";
import { AnnuityPaymentsType } from "../../../../../../Wrap/Constants/Enums/Domain/AnnuityPaymentsType";
import { PaymentPayer } from "../../../../../../Wrap/Constants/Enums/Payments/PaymentPayer";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";

export enum processTypeEnum {
    Quote,
    NewBusiness,
    SinglePaymentTransfer,
    RegularPayment,
    topUpWithITFLS,
    GadReview,
    NewBusinessExistingClient,
    NewQuoteExistingClient,
    TakePensionBenefits,
    EditIncomePayments,
    WhatIfTool,
    OneOffIncomePayment,
    ConvertCappedToFlexi,
    PPToISA,
    PPToSIPP
}

export const ContinueArrays = [];

export const ContinueArraysMap = {
    [Frequency.Monthly]: "Until Notified",
    [Frequency.Quarterly]: "Until Date",
};

export const ExternalIsaContributionTypeMap = {
    [ExternalIsaContributionType.CurrentTaxYear]: "Current",
    [ExternalIsaContributionType.PreviousTaxYear]: "Non-Current",
    [ExternalIsaContributionType.PreviousAndCurrentTaxYear]: "Both",
};
export const FinancialAdviceHardStop = [
    ProcessType.NB,
    ProcessType.NBEC,
]

export const FinancialAdviceFirstDrawdownHardStop = [
    ProcessType.TopUpWithITFLS,
    ProcessType.TakePensionBenefits
]

export enum PaymentType {
    Client = "Client",
    ClientIncome = "ClientIncome",
    ThirdParty = "Third-party",
    Employer = "Employer",
    EmployerSalaryDeduction = "Salary deduction",
    AssumedBond = 'AssumedBond',
}

export const PaymentPayerToPaymentTypeMap = {
    [PaymentType.Client]: PaymentPayer.Client,
    [PaymentType.ThirdParty]: PaymentPayer.ThirdParty,
    [PaymentType.Employer]: PaymentPayer.Employer,
    [PaymentType.EmployerSalaryDeduction]: PaymentPayer.EmployerSalaryDeduction
}

export const TransferInModelMap = {
    [SubAccountType.Sipp]: "PensionTransfers",
    [SubAccountType.JuniorSipp]: "PensionTransfers",
    [SubAccountType.Npr]: "PensionTransfers",
    [SubAccountType.StocksIsa]: "IsaTransfers",
    [SubAccountType.InvestmentAccount]: "GiaTransfers",
};

export const BankAccountOwnerPaymentTypeMap = {
    [BankAccountOwner.Individual]: [PaymentType.Client],
    [BankAccountOwner.Joint]: [PaymentType.Client],
    [BankAccountOwner.Partner]: [PaymentType.Client],
    [BankAccountOwner.Employer]: [PaymentType.Employer, PaymentType.Client, PaymentType.EmployerSalaryDeduction],
    [BankAccountOwner.ThirdParty]: [PaymentType.ThirdParty],
    [BankAccountOwner.Trust]: [PaymentType.Client],
    [BankAccountOwner.Client1]: [PaymentType.Client],
    [BankAccountOwner.Client2]: [PaymentType.Client],
};

export const PayeeType = {
    Client: PaymentType.Client,
    ThirdParty: PaymentType.ThirdParty,
    Employer: PaymentType.Employer,
};

export const datePickerOptions = {
    showYearDropdown: true,
    todayButton: ContentDatePicker.Today,
    isClearable: true,
    dateFormat: ContentDatePicker.DateFormat,
    acceptDateFormats: ACCEPT_DATE_FORMATS,
    alwaysValidateOnUpdate: false,
};

export const depositMethodArrays = [
    DepositMethod.Cheque,
    DepositMethod.DirectCredit,
    DepositMethod.DirectDebit,
    DepositMethod.WrapCash,
];
export const depositMethodArraysMap = {
    [DepositMethod.Cheque]: "Cheque",
    [DepositMethod.DirectCredit]: "Direct Credit",
    [DepositMethod.DirectDebit]: "Direct Debit",
    [DepositMethod.WrapCash]: "Cash Account",
};

export const batchTypeArrays = [BatchType.OneOff, BatchType.Standing];
export const batchTypeArraysMap = {
    [BatchType.OneOff]: "One-off",
    [BatchType.Standing]: "Standing",
    [BatchType.Auto]: "Auto",
};

export const OrderFrequencyTypeArrays = [
    Frequency.Fortnightly,
    Frequency.Monthly,
    Frequency.Quarterly,
    Frequency.HalfYearly,
    Frequency.Yearly,
];

export const OrderDeferReasonTypeArrays = [
    OrderDeferReasonType.Other,
    OrderDeferReasonType.AnnuityPurchase,
    OrderDeferReasonType.Cancellation,
    OrderDeferReasonType.Death,
    OrderDeferReasonType.SeriousIllHealth,
    OrderDeferReasonType.Drawdown,
    OrderDeferReasonType.Income
];

export const OrderDeferReasonArraysMap = {
    [OrderDeferReasonType.AnnuityPurchase]: "Annuity Purchase",
    [OrderDeferReasonType.Cancellation]: "Cancellation",
    [OrderDeferReasonType.Death]: "Death",
    [OrderDeferReasonType.SeriousIllHealth]: "Serious Ill Health",
    [OrderDeferReasonType.Drawdown]: "Drawdown",
    [OrderDeferReasonType.Income]: "Income",
    [OrderDeferReasonType.Other]: "Other"
    };

export const OrderFrequencyArraysMap = {
    [Frequency.Fortnightly]: "Fortnightly",
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half Yearly",
    [Frequency.Yearly]: "Yearly",
};

export const regularDepositMethodArrays = [
    RegularDepositMethod.Cheque,
    RegularDepositMethod.BACS,
    RegularDepositMethod.DirectDebit,
    RegularDepositMethod.ProductWrapperCash,
];

export const regularDepositMethodArraysMap = {
    [RegularDepositMethod.Cheque]: "Cheque",
    [RegularDepositMethod.BACS]: "BACS",
    [RegularDepositMethod.DirectDebit]: "Direct Debit",
    [RegularDepositMethod.ProductWrapperCash]: "Cash Account",
    [RegularDepositMethod.DirectCredit]: "Direct Credit",
    [RegularDepositMethod.CHAPS]: "CHAPS",
    [RegularDepositMethod.Faster]: "Faster",
    [RegularDepositMethod.CashSubAccount]: "Product Cash",
    [RegularDepositMethod.SpecifiedSubAccount]: "Specified Sub Account",
    [RegularDepositMethod.NotSpecified]: "",
};

export const daysUntilFirstPaymentDate = 20;

export const MoneyPurchaseAnnualAllowanceSourceArray = [
    MoneyPurchaseAnnualAllowanceSource.NotSpecified,
    MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls,
    MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum,
    MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment,
];

export const MoneyPurchaseAnnualAllowanceSourceArrayMap = {
    [MoneyPurchaseAnnualAllowanceSource.NotSpecified]: "Unknown",
    [MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls]: "Uncrystallised pension saving lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum]: "Standalone lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment]: "Flexible-access drawdown payment",
};

export const WithdrawalMethodArray = [WithdrawalMethod.TransferToWrapCash, WithdrawalMethod.BankAccount];

export const WithdrawalMethodMap = {
    [WithdrawalMethod.TransferToWrapCash]: "Transfer to Cash account",
    [WithdrawalMethod.BankAccount]: "Transfer to nominated Bank account",
};

export const FrequencyTypeArrays = [Frequency.Monthly, Frequency.Quarterly, Frequency.HalfYearly, Frequency.Yearly];

export const FrequencyArraysMap = {
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half yearly",
    [Frequency.Yearly]: "Yearly",
};

export const FrequencyTypeArraysMaps = {
    [FrequencyType.NotSpecified]: "Not specified",
    [FrequencyType.Daily]: "Daily",
    [FrequencyType.Weekly]: "Weekly",
    [FrequencyType.Monthly]: "Monthly",
    [FrequencyType.Quarterly]: "Quarterly",
    [FrequencyType.HalfYearly]: "Half yearly",
    [FrequencyType.Yearly]: "Yearly",
    [FrequencyType.Fortnightly]: "Fortnightly",
    [FrequencyType.Termly]: "Termly",
};

export const AdviceTypeArrays = [AccountAdviceType.NonDiscretionary, AccountAdviceType.Discretionary];

export const AdviceTypeArraysMap = {
    [AccountAdviceType.NonDiscretionary]: "Non-discretionary",
    [AccountAdviceType.Discretionary]: "Discretionary",
};

export const TransferKeysMap = {
    [SubAccountType.PersonalPortfolio]: "GiaTransfers",
    [SubAccountType.Sipp]: "PensionTransfers",
    [SubAccountType.StocksIsa]: "IsaTransfers",
};

export const ArrangementTypeMap = {
    [ArrangementType.NotSpecified]: "NotSpecified",
    [ArrangementType.ExpressionOfWish]: "Expression of wish",
    [ArrangementType.Trust]: "Trust",
    [ArrangementType.DeathOfBenefit]: "DeathOfBenefit",
    [ArrangementType.Partner]: "Partner"
};

export const CertificatedSharesAndEquityText =
    "If a combination of certificated investments and non certificated investments –" +
    "then a separate transfer must be submitted for each.Please ensure that the certificated" +
    " numbers are provided below. Once the transfer is completed the shares will be held electronically";

export const RegisteredOwnersText =
    "The Name(s) of the registered holder(s) must be given in full as recorded by the custodian These" +
    " ownership details can be amended as required";
export const ConductBusinessAuthorisedQuestionText = "Are you appropriately authorised to conduct this business?";
export const AdviceGivenQuestionText = "Did you give financial advice?";
export const AdviceGivenIncludingPersonalRecommendationQuestionText = "Did you give financial advice? (Including a personal recommendation)";
export const MpaaQuestionText = "Is your client subject to the Money Purchase Annual Allowance (MPAA)?";

export const DpcQuestionText = "Are any transfers subject to disqualified pension credits?";
export const DpcWarningText = "The disqualifying pension credit will be held under a separate header account. Please note you will only be able to capture a single transfer as part of this application, if there are further transfers which are not subject to disqualifying pension credit or further single or regular payments in are required, or you wish to make a drawdown request as part of this application, please contact us on 0345 279 1001."
export const InvalidDpcTransferWarningText = "This contribution cannot continue online as a new pension must be opened, \
    please apply via a paper application form."
export const InvalidNonDpcTransferWarningText = "This account is marked as a Disqualifying Pension credit account.\
    Unable to process this application for a non Disqualifying pension credit Transfer in."
export const IsRestrictedToPensionContributionWarningText =
    "Contributions into this pension account are restricted as customer has Enhanced/Fixed protection that has been granted on or after 15 March 2023."
export const EmployerInfoIcon =
    `Employer – Salary Deduction payments are paid via an employer bank account and deducted from the employee's net salary. These payments are treated like client contributions for pension tax relief. This should not be confused with Salary Sacrifice, where the employee has agreed to a reduced gross salary in return for pension contributions from their employer. Salary Sacrifice arrangements should be entered as an 'Employer' payment.`

export const PensionAnnuityAssumptionText ={
    QuestionText:"Would you like to edit annuity assumptions?",
    PaymentInLabel:"Annuity Payment In",
    SpousePensionQsText:"Would you like to add a spouses pension?"
}

export const AnnuityPaymentsTypeOptions = [AnnuityPaymentsType.Advance, AnnuityPaymentsType.Arrears];

export const AnnuityPaymentsTypeOptionsMap = {
    [AnnuityPaymentsType.Advance]: "Advanced",
    [AnnuityPaymentsType.Arrears]: "Arrears"
};

export const PensionAnnuityAssumptionPensionIncreaseArray = [0,0.5,1.0,1.5,2.0,2.5,3.0,3.5,4.0,4.5,5.0,5.5,6.0,6.5,7.0,7.5,8.0,8.5,"RPI"];
export const PensionAnnuityAssumptionGuaranteePeriodArray = [0,1,5,10];

export const PaymentMethodTypeOptions = [PaymentMethod.Bacs, PaymentMethod.Faster, PaymentMethod.Chaps];

export const PaymentMethodArraysMap = {
    [PaymentMethod.Bacs]: "BACS",
    [PaymentMethod.Chaps]: "CHAPS",
    [PaymentMethod.Faster]: "Faster",
    [PaymentMethod.Swift]: "Swift",
    [PaymentMethod.InternalTransfer]: "InternalTransfer",
};

export const PensionTypesArray = [
    PensionType.None,
    PensionType.TakePensionBenefits,
    PensionType.ImmediateTaxFreeLumpSum,
];

export const PensionTypesArrayNoITFLS = [
    PensionType.None,
    PensionType.TakePensionBenefits
];

export const PensionTypesMap = {
    [PensionType.None]: "No",
    [PensionType.TakePensionBenefits]: "Take pension benefits",
    [PensionType.ImmediateTaxFreeLumpSum]: "Immediate tax-free lump sum",
};

export const RegularIncomePaymentAlertMsg = {
    Frenquency: "Please update this frequency on the drawdown step",
    FirstPaymentDate:
        "Changing the payment date will amend the payment date across all pension arrangements and any regular drawdown schedules",
    EndDate: "No further payments will be made after the date entered in this field",
};

export const SourceTypeArray = [SourceType.ProductCash, SourceType.WrapCash];

export const SourceTypeMap = {
    [SourceType.ProductCash]: "Product cash",
    [SourceType.WrapCash]: "Cash Account",
};

export const DrawdownTypeOptions = [SippDrawdownType.Flexible, SippDrawdownType.No, SippDrawdownType.Capped];

export const DrawdownTypeOptionsMap = {
    [SippDrawdownType.Flexible]: "Flexible-access single",
    [SippDrawdownType.No]: "Regular drawdown",
    [SippDrawdownType.Capped]: "Capped single",
};

export const CrystallisationOptions = ["Full", "Partial"];

export const crystallisationAmountErrorMessage = {
    valueToCrystalliseIsZero:
        "The value available to crystallise is zero so you cannot complete the drawdown at this time.",
    inputIsZeroAndLessThanUncrystallised:
        "Please enter a drawdown amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputIsZeroAndEqualUncrystallised:
        "Please enter a drawdown amount that is greater than zero and less than the value available to crystallise.",
    inputEqualValueToCrystallise:
        'The amount you have entered is equal to the total value available to crystallise. If you want to crystallise the whole amount, please choose "Full" for your drawdown options.',
    inputGreaterThanValueToCrystalliseAndLessThanUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a drawdown amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputGreaterThanValueToCrystalliseAndEqualUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a drawdown amount that is greater than zero and less than the value available to crystallise.",
};

export const drawdownDetailsMessage = {
    NeedIllHealthErrorMessage: "To take drawdown, Customer whose age < 55 must have ill health.",
    crystallisationOptionErrorMessage:
        "You will need to cancel the process because the client has entitlements that require this to be a full drawdown, but the value available to crystallise is less than the uncrystallised fund value.",
    LTAInputErrorMessage:
        "Please enter a value for the LTA crystallised off platform that is equal to or greater than 0%",
    regularCrystallisationAmountErrorMessage: "Please enter an amount that is greater than zero",
    HasTailoredDrawdownErrorMessage :"Tailored Drawdown cannot be selected because the Aberdeen SIPP holds non-compatible assets. Please review and amend your client's investments if you wish to proceed."
};

export const LTADetailHeading = {
    previousLTA: "Lifetime allowance (LTA) previously used in this account",
    LTABefore2006: "LTA used by benefits that commenced before 6 April 2006",
    availableLTA: "Available LTA",
    otherLTA: "Other LTA used you need to tell us about",
    LTAByThisCrystallisation: "LTA % used by this drawdown",
    LTAInTotal: "LTA % used in total following this drawdown",
    crystallisationAmountSubjectToLTAExcessCharge: "Amount of drawdown subject to LTA excess charge",
    estimateLTAForInitialCrystallisation: "Estimated LTA % usage for initial drawdown",
    estimateLTAPerRegularCrystallisation: "Estimated LTA % usage per regular drawdown",
    estimateAvailableLTAInAYear: "Estimated available LTA after a year",
    estimateLTAUsedInAYear: "Estimated LTA that will be used after a year",
    estimateTotalLTAUsedInAYear: "Estimated total LTA that will be used after a year",
    estimatedChargeableCrystallisation: "Estimated chargeable portion of drawdown after a year",
    crystallisationChargeablePortion: "Chargeable portion of drawdown",
};

export const LTADetailTooltiopMessage = {
    previousLTA: "TBC by Pension pod/SL props",
    otherLTA: "TBC by Pension pod/SL props",
    LTAByThisCrystallisation:
        "This is the percentage of the lifetime allowance for the current tax year that will be used by your client's drawdown.",
    LTAInTotal:
        "This is the total lifetime allowance for the current tax year that will be used once this drawdown is added to any previous drawdowns taken by your client.",
    estimatedChargeableCrystallisation:
        "This is the estimated amount that we will crystallise in order to achieve the required income",
};

export const DeferredFundWarningMessage = {
    CannotSwitchFromDeferredFundWarning: "The following Insured fund <InstrumentCode> is marked as deferred, and so a 'Switch from' order cannot be placed on this asset. If you wish to sell the asset, you will have to do so through the sell wizard in order to sell this down separately.",
    LessThanProportionalHoldingValueWarning: "Please enter an amount less than the proportional holding value of this fund."
};

export const OffPlatformAssetCharge ={
   OffPlatformAssetRelateCharges: "Related charges",
   InitialAdministrationCharge: "If this is your first investment in the Off platform range, you will face an Initial Administration charge - ",
   YearlyAdministrationCharge:"A yearly administration charge will be incurred for any Off platform assets held within your portfolio within the past year - ",
   TransactionCharge:"A Off platform Transaction charge will be applied for any Buy or sell within this range - ",
   AdditionalFee:"Addition fees may be incurred if this Asset is an off platform DFM or if your Pension holds a Drawdown arrangement"
}

export const feeTranTypeKey =
{
    InitialAdministrationCharge: "Initial Administration Charge",
    YearlyAdministrationCharge: "Yearly Administration Charge",
    TransactionCharge: "External Transaction Charge"
}

export const EstimatedPayeMessage = {
	error: "Sorry, calculations are currently unavailable",
	message: "The estimated calculations are based on the tax code and basis above which we currently hold for your client, therefore this will be the tax code used for any payments out. The tax they pay upfront may be different to their final tax position, HMRC could come back at any time with a revised tax code."
}

export const SIPPPaymentInCheckboxGroupTexts = {
    TaxReliefSubtitle: "Payment with tax relief (optional), paid by:",
    NoTaxReliefSubtitle: "Payment with no tax relief, paid by:"
}
